// extracted by css-extract-rspack-plugin
export default {"EditingParameterContainer":"ParameterWidget-module__EditingParameterContainer___AejB5","isEditingParameter":"ParameterWidget-module__isEditingParameter___YdNUe"};